const Items = [
  {
    id: 1,
    mainImage: require("../assets/projects/ec-1.png"),
    img: [
      require("../assets/projects/ec-1.png"),
      require("../assets/projects/ec-2.png"),
      require("../assets/projects/ec-3.png"),
    ],
    features: [
      "User registration and login",
      "Authentication using JWT Tokens",
      "Story searching and pagination",
      "CRUD operations (Story create, read, update and delete)",
      "Upload user ımages and story ımages to the server",
      "Liking stories and adding stories to the Reading list",
      "Commenting on the story",
      "Skeleton loading effect",
      "Responsive Design",
      "404 Page and many more.",
    ],
    technologies: [
      "Next.js",
      "React Hooks",
      "React Icons",
      "Axios",
      "CSS",
      "UUID",
      "NodeJS",
      "ExpressJS",
      "MongoDB",
      "Mongoose",
      "Express Asynsc Handler",
      "Json Web Token",
      "Bcryptjs",
      "Nodemailer",
      "Dontenv",
      "Multer",
      "Slugify",
      "Cors",
      "RazerPay",
    ],
    title: "Eezer Ecommerce Shoping Application",
    description:
      "Fullstack open source ecommerce application made with MongoDB, Express, React & Nodejs (MERN)",
    category: "Ecommerce",
    liveLink: "https://garments-iota.vercel.app/",
    codeLink: "https://github.com/Sankar4595/garments.git",
  },

  {
    id: 2,
    mainImage: require("../assets/projects/ad1.png"),
    img: [
      require("../assets/projects/ad1.png"),
      require("../assets/projects/ad2.png"),
      require("../assets/projects/ad3.png"),
    ],
    features: [
      "User Authentication with JWT",
      "Ecommerce Product Management",
      "Orders Tracking for Customers",
      "Payment Integration with Razorpay",
      "Add New Product",
      "Product Dashboard with Charts and Visualizations",
    ],
    technologies: [
      "React",
      "React Hooks",
      "React Icons",
      "Axios",
      "CSS",
      "UUID",
      "NodeJS",
      "ExpressJS",
      "MongoDB",
      "Mongoose",
      "Express Asynsc Handler",
      "Json Web Token",
      "Bcryptjs",
      "Nodemailer",
      "Dontenv",
      "Multer",
      "Slugify",
      "Cors",
      "Razorpay",
    ],
    title: "Eezer Admin Panel",
    description:
      "Eezer web application developed using the MERN stack for secure user authentication, product management, orders tracking, payment integration, and a product dashboard.",
    category: "Ecommerce",
    liveLink: "https://eezer-admin.vercel.app/login",
    codeLink: "https://github.com/Sankar4595/eezer-admin.git",
  },
  {
    id: 3,
    mainImage: require("../assets/projects/da-1.jpg"),
    img: [
      require("../assets/projects/da-1.jpg"),
      require("../assets/projects/da-2.jpg"),
      require("../assets/projects/da-3.jpg"),
      require("../assets/projects/da-4.jpg"),
      require("../assets/projects/doctorapp.png"),
    ],
    features: [
      "User Authentication with JWT",
      "Doctor Profile Management",
      "Appointment Scheduling",
      "Patient Records Management",
      "Payment Integration with Razorpay",
      "Real-time Notifications",
      "Dashboard with Charts and Visualizations",
    ],
    technologies: [
      "React Native",
      "React Hooks",
      "React Navigation",
      "Axios",
      "TypeScript",
      "NodeJS",
      "ExpressJS",
      "MongoDB",
      "Mongoose",
      "Express Async Handler",
      "Json Web Token",
      "Bcryptjs",
      "Nodemailer",
      "Dotenv",
      "Multer",
      "Slugify",
      "Cors",
      "Razorpay",
    ],
    title: "Doctor Appointment Mobile App",
    description:
      "A comprehensive mobile application developed using the MERN stack for secure user authentication, doctor profile management, appointment scheduling, patient records management, payment integration, and real-time notifications.",
    category: "MobileApp",
    liveLink:
      "https://drive.google.com/uc?export=download&id=1x4UHu0xfC1gALEtrxHULwJgQrv7AY_yX",
    codeLink: "https://github.com/Sankar4595/doctorappoinment.git",
  },
];

export default Items;
